export const environment = {
  production: false,
  apiUrlDynamicForm: 'https://asv-client-form-portal-be.k3s.flycatchtech.in',
};
